<template>
  <div class="term card card-body pt-0" style="border-radius: 10px; ">
    <div>
          <a class="btn-basic float-right mt-3" @click="download(term)" style="color:white">Download</a>
          
          <!-- header -->
          <div class="term_header mt-4">
            <!-- title -->
            <h6 class="color-default font-weight-bold float-left mt-1">Terms And Conditions</h6>
            <span class="clearfix d-block mb-3"></span>
          </div>
          <hr>
          <!-- term Content -->
          <div class="term_content">
            <div class="text-center">
            </div>
            <p v-html="body"></p>
          </div>
          <hr>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  Vue.use(Loading);
  let loader;

  export default {
    computed: {
      term: function () {
        return this.$store.getters['termsandconditions/term'];
      },

      body: function () {
        if (this.term.value) {
          return this.term.value;
        } else {
          return 'No content';
        }
      }
    },
    created: function () {
      this.$store.dispatch('termsandconditions/getTerm', this.$route.params.term);
    },
    methods: {
      publishing(action) {
        this.$store.dispatch('posts/publishing', {
          post: this.post,
          action: action
        })
          .then((response) => {
            this.$store.dispatch('message/update', {
              title: this.post.title,
              body: response.data.message,
              class: 'success',
              confirm: false
            }, { root: true });
          });
      },
      download(term) {
        // loader = Vue.$loading.show({
        //   loader: 'dots'
        // }); ...permission
         const permission = {
      headers: {
        'X-Permission': 'term_condition_create' 
      }
    }; 
        axios.post('/admin/termsandconditions/download', term, { responseType: 'arraybuffer', ...permission })
          .then((response) => {
            // Extract File extension so its related mimeType can be given while creating blob
            var fileExt = 'pdf';
            let mimeType = 'application/pdf';

            // It is necessary to create a new blob object with mime-type explicitly set
            var newBlob = new Blob([response.data], { type: mimeType });
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            link.href = data;
            link.download = 'TermsAndConditions';
            link.click();

            // Downloading File here
            setTimeout(function () {
              window.URL.revokeObjectURL(data)
              // loader.hide()
            }, 500)
          })
          .catch((error) => {
            // send error message
            this.$store.dispatch('message/update', {
              title: 'Downloading Failed',
              class: 'danger',
              body: error.response.data.message,
              errors: error.response.data.errors,
              confirm: false
            }, { root: true });
          });
      },

    }
  }
</script>
<style>
  .term_content {
    padding: 0 10px;
    background-color: #ffffff;
    font-size: 16px;
  }
</style>